import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { restoreAll } from '../restoreAll';
import { RootState } from '..';

export interface MediaQueryState {
    width: number;
}

interface IUpdateWidthAction {
    width: number;
}

const initialState: MediaQueryState = {
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
};

export const mediaQuery = createSlice({
    name: 'mediaQuery',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        updateWidth: (state, action: PayloadAction<IUpdateWidthAction>) => {
            state.width = action.payload.width;
        },
    },
});

export const mediaQueryAction = mediaQuery.actions;

export const selectMediaWidth = (state: RootState) => state.mediaQuery.width;

export default mediaQuery.reducer;
